module.exports = __webpack_public_path__ + "img/login-bg.111addc8.png";